import React from 'react';
import { motion } from 'framer-motion';
export function PricingSection() {
  return <section className="bg-white py-10 px-6 md:py-16" data-id="element-220">
      <div className="max-w-3xl mx-auto" data-id="element-221">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center space-y-6" data-id="element-222">
          <h2 className="font-playfair text-3xl md:text-4xl text-charcoal mb-8" data-id="element-223">
            Pourquoi seulement 27$ ?
          </h2>

          <p className="text-lg leading-relaxed" data-id="element-224">
            Parce que j'ai vécu cette solitude du dimanche soir. Je sais ce que
            c'est de compter ses sous après une séparation. De vouloir investir
            en soi mais de ne pas pouvoir se permettre un coaching à 500$.
          </p>

          <p className="text-lg leading-relaxed" data-id="element-225">
            Ce guide est mon engagement envers chaque maman:
          </p>

          <blockquote className="font-playfair italic text-2xl md:text-3xl text-burgundy py-8" data-id="element-226">
            "Tu mérites de te retrouver, et ce soir, tu peux commencer pour le
            prix d'un repas."
          </blockquote>

          <motion.button whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="bg-burgundy text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-opacity-90 transition-all shadow-lg whitespace-nowrap" onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-227">
            Je Mérite Ma Renaissance →
          </motion.button>
        </motion.div>
      </div>
    </section>;
}